import Axios from 'axios'

const createAxiosInstance = () => {
  const axiosInstance = Axios.create({
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
    timeout: 20000,
    withCredentials: true,
  })
  delete axiosInstance.defaults.headers.common.Authorization
  return axiosInstance
}

export const NoInterceptorAxiosInstance = createAxiosInstance()
